import useResidentsList from 'hooks/useResidentsList'
import { type FC, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { VISIT } from 'screens/Rostering/constants'
import {
  AboutShiftSection,
  AboutVisitSection,
  ServiceUserDetailsSection
} from '../sections'
import type { ModalSectionProps, RotaPatternModalType } from '../utils'

export const AboutStep: FC<
  ModalSectionProps & {
    type?: RotaPatternModalType
  }
> = ({ formData, form, type, setFormData }) => {
  const params = useParams()

  const isVisit = type === VISIT

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    if (params?.id && isVisit && !formData?.subjectId) {
      setFormData?.({ subjectId: params.id, reoccurenceTooglePattern: true })
      form?.setFieldValue('subjectId', params.id)
      form?.setFieldValue('reoccurenceTooglePattern', true)
    }
  }, [params?.id, formData])

  const { residents } = useResidentsList({})

  const selectedResident = formData?.subjectId

  const foundResident = residents?.find(
    (resident) => resident?.id === selectedResident
  )

  const hasOneAddress = foundResident?.addresses?.length === 1

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    if (hasOneAddress) {
      form?.setFieldValue(
        'addressId',
        (foundResident?.addresses?.[0] as any)?.id ||
          // eslint-disable-next-line no-underscore-dangle
          (foundResident?.addresses?.[0] as any)?._id
      )
    }
  }, [hasOneAddress, selectedResident])

  return (
    <>
      {isVisit && (
        <>
          <ServiceUserDetailsSection form={form} formData={formData} />
          <AboutVisitSection />
        </>
      )}
      {!isVisit && <AboutShiftSection />}
    </>
  )
}
